import {
    ACCOUNT_MEMBER_INVITE,
    ACCOUNT_MEMBER_INVITE_FAIL,
    ACCOUNT_MEMBER_INVITE_RESET,
    ACCOUNT_MEMBER_INVITE_SET_PARAMS,
    ACCOUNT_MEMBER_INVITE_SUCCESS,
} from './constants';

//
export const accountMemberInviteReset = () => ({
    type: ACCOUNT_MEMBER_INVITE_RESET,
    payload: null,
});
export const accountMemberInviteSetParams = ({params}) => ({
    type: ACCOUNT_MEMBER_INVITE_SET_PARAMS,
    payload: {params},
});
export const accountMemberInvite = ({params}) => ({
    type: ACCOUNT_MEMBER_INVITE,
    payload: {params},
});
export const accountMemberInviteSuccess = (data) => ({
    type: ACCOUNT_MEMBER_INVITE_SUCCESS,
    payload: data,
});
export const accountMemberInviteFail = (data) => ({
    type: ACCOUNT_MEMBER_INVITE_FAIL,
    payload: data,
});